<template>
  <v-layout column align-center class="text-xs-center subheading">
    <div class="w-100">
      {{ $t('tagId.tag_placement')}}
    </div>
    <tag-image class="my-3"/>
    <card-image class="my-3"/>
    <div class="w-100">
      {{ $t('tagId.id_description')}}
    </div>
  </v-layout>
</template>
<script>
import TagImage from '@/assets/TagWithID.svg'
import CardImage from '@/assets/CardWithID.svg'
export default {
  components: {
    TagImage,
    CardImage
  }
}
</script>
